import { useState } from "react";
import { toast } from "sonner";
import { fileService } from "@/services/ServiceRegistry";
import { useUpdateRoom } from "@/hooks/useRooms";
import { UpdateRoomRequest } from "@/types/room";

export const useRoomUpdate = (id: string, hotelId: string) => {
  const updateRoomMutation = useUpdateRoom();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleRoomUpdate = async (
    data: UpdateRoomRequest,
    selectedPhotoFile: File | null,
    currentPhotoId?: string,
  ) => {
    try {
      setIsLoading(true);

      let uploadedPhotoId = currentPhotoId;

      if (selectedPhotoFile) {
        try {
          uploadedPhotoId =
            await fileService.uploadFileWithPresignedUrl(selectedPhotoFile);
        } catch (uploadError) {
          console.error("Failed to upload photo:", uploadError);
          toast.error("Photo upload failed");
        }
      }

      const updateRequest: UpdateRoomRequest = {
        ...data,
        photoId: uploadedPhotoId ?? null,
      };

      await updateRoomMutation.mutateAsync({
        id,
        hotelId,
        data: updateRequest,
      });

      toast.success("Room updated successfully!");
    } catch (err) {
      const message = (err as Error).message || "Update failed";
      setError(message);
      toast.error(message);
      console.error("Error updating room:", err);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    handleRoomUpdate,
    isLoading,
    error,
  };
};
